import { createReducer } from "@reduxjs/toolkit";
import { retrieveUninvitedUsers } from "./retrieve-uninvited-users";
import type { RetrievalState } from "@redux/state/shared-types";
import type { UninvitedUserVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<UninvitedUserVM[]> = { data: [], fetching: "idle" };

export const retrieveUninvitedUsersReducer = createReducer<RetrievalState<UninvitedUserVM[]>>(initialState, builder => {
  builder.addCase(retrieveUninvitedUsers.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveUninvitedUsers.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveUninvitedUsers.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
